var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.data || _vm.data.length === 0)?_c('div',{staticClass:"text-center pa-5 grey--text"},[_vm._v(" No data available ")]):_c('div',{staticClass:"chart-container"},[_c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }